<template>
  <v-container>
    <v-row justify="center">
      <v-col
        v-for="site in siteList"
        :key="site.ParkingReserved_ID"
        :md="6"
        :cols="12"
      >
        <v-card color="lighten-3">
          <v-card-title class="text-h4 font-weight-bold d-none d-sm-flex">
            <v-icon
              large
              class="mr-1"
              color="green darken-2"
            >mdi-ticket</v-icon>{{ site.ParkingReserved_CustomName }}
          </v-card-title>
          <v-card-title class="text-h5 font-weight-bold d-flex d-sm-none">
            <v-icon
              class="mr-1"
              color="green darken-2"
            >mdi-ticket</v-icon>{{ site.ParkingReserved_CustomName }}
          </v-card-title>
          <v-card-text>
            <p class="ml-md-10 text-sm-left text-h6 text--primary font-weight-bold">
              聯絡電話: {{ site.ParkingReserved_Tel }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              dark
              color="primary"
              :to="'/reservedindex/' + site.ParkingReserved_ID"
            >
              前往
              <v-icon
                dark
                right
              >mdi-chevron-right-circle</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  data: () => ({
    siteList: []
  }),
  created() {
    this.dbio('/ParkingOnlyReserved/GetParkingReserved').then((response) => {
      this.siteList = response;
    });
  },
  mounted() {}
};
</script>
